import { render, staticRenderFns } from "./QuickDeclareSummaryButtonSet.vue?vue&type=template&id=ffebc964&scoped=true&"
import script from "./QuickDeclareSummaryButtonSet.vue?vue&type=script&lang=js&"
export * from "./QuickDeclareSummaryButtonSet.vue?vue&type=script&lang=js&"
import style0 from "./QuickDeclareSummaryButtonSet.vue?vue&type=style&index=0&id=ffebc964&lang=scss&scoped=true&"
import style1 from "./QuickDeclareSummaryButtonSet.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffebc964",
  null
  
)

export default component.exports